import { z } from 'zod';
// ============================================================
// TemplateConfig — DB templates.config JSON 스키마
// ============================================================
const TemplateStyleSchema = z.object({
    primaryColor: z.string().optional(),
    secondaryColor: z.string().optional(),
    backgroundColor: z.string().optional(),
    fontSerif: z.string().optional(),
    fontSans: z.string().optional(),
    heroHeight: z.number().optional(),
    sectionSpacing: z.enum(['compact', 'normal', 'spacious']).default('normal'),
});
export const TemplateConfigSchema = z.object({
    componentId: z.string(),
    style: TemplateStyleSchema.default({ sectionSpacing: 'normal' }),
    options: z.record(z.string(), z.unknown()).default({}),
});
/** 기본 TemplateConfig (classic 템플릿) */
export const DEFAULT_TEMPLATE_CONFIG = {
    componentId: 'classic',
    style: { sectionSpacing: 'normal' },
    options: {},
};
//# sourceMappingURL=template.js.map